<div class="checkbox-container">
  <mat-checkbox
    [checked]="checkboxState"
    [disableRipple]="true"
    [ngClass]="theme"
    [indeterminate]="indeterminate"
    (click)="stopPropagation($event)"
    (change)="checkboxClick($event)" />
  <span *ngIf="text" class="checkbox-text">{{text}}</span>

</div>
